import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, IInitialState } from '../../../../reduxService';
import * as BeMaccaferriStoreHelper from '../../../api/store/BeMaccaferriStoreHelper';
import { IGeogridData, IGeogridItem } from '../../../api/IApiResponse';

/**
 * Interfaccia per i dati specifici che il grafico necessita per l'aggiornamento in tempo reale.
 * Potrebbe essere un sottoinsieme di IGeogridData o una sua trasformazione.
 * Per ora, usiamo una struttura simile a IGeogridData per semplicità,
 * ma potresti limitarla solo ai campi effettivamente usati dal grafico per l'anteprima.
 */
export interface IGraphicPreviewData {
    geogridBaseCourse?: {
        thickness?: number;
        geogrids?: IGeogridItem[];
    };
    geogridSubBaseCourse?: {
        thickness?: number;
        geogrids?: IGeogridItem[];
    };
    surfaceLayer?: {
        thickness?: number;
    };
    type?: {
        geogridType?: string;
    };
    // Aggiungi altri campi se il grafico ne ha bisogno per l'anteprima in tempo reale
    // Esempio:
    // load?: {
    //     deckHalfWidth?: number;
    //     // ... altri campi di load
    // };
    // truck?: {
    //     wheelRadius?: number;
    //     // ... altri campi di truck
    // };
}

interface ComponentiGraficiState {
    previewData: IGraphicPreviewData | null;
    // Potresti aggiungere qui altri stati specifici per i componenti grafici, se necessario
}

const initialState: ComponentiGraficiState = {
    previewData: null,
};

const componentiGraficiSlice = createSlice({
    name: 'componentiGrafici',
    initialState,
    reducers: {
        /**
         * Imposta o aggiorna i dati di anteprima per i componenti grafici.
         * @param state Lo stato corrente dello slice.
         * @param action L'azione contenente i nuovi dati di anteprima.
         */
        setGraphicPreviewData: (state, action: PayloadAction<IGraphicPreviewData | null>) => {
            state.previewData = action.payload;
            // Se vuoi fare un merge invece di una sovrascrittura completa:
            // state.previewData = action.payload ? { ...state.previewData, ...action.payload } : null;
            //console.log('[componentiGraficiSlice] setGraphicPreviewData called, new previewData:', action.payload);
        },
        /**
         * Resetta i dati di anteprima allo stato iniziale.
         * @param state Lo stato corrente dello slice.
         */
        clearGraphicPreviewData: state => {
            state.previewData = null;
            //console.log('[componentiGraficiSlice] clearGraphicPreviewData called');
        },
    },
});

export const { setGraphicPreviewData, clearGraphicPreviewData } = componentiGraficiSlice.actions;

// Selettori
export const selectGraphicPreviewData = (state: RootState): IGraphicPreviewData | null => state.componentiGrafici.previewData;

export default componentiGraficiSlice.reducer;
